import { render, staticRenderFns } from "./selectcontrol.vue?vue&type=template&id=62084424&scoped=true&"
import script from "./selectcontrol.vue?vue&type=script&lang=js&"
export * from "./selectcontrol.vue?vue&type=script&lang=js&"
import style0 from "./selectcontrol.vue?vue&type=style&index=0&id=62084424&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62084424",
  null
  
)

export default component.exports